import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Info,
  Delete,
  Edit,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import BuildingInfo from "../dialogs/Info";
import { Box, IconButton, Stack } from "@mui/material";
import "../styles.css";
import useFillHeight from "../utils/useFillHeight";
import { formatTableDate as getDate } from "../utils/dates";

export default function ClientsDataTable({
  items,
  handleOpenInfo,
  handleDeleteItem,
  handleEditItem,
  loadNextClients,
  admin,
}) {
  const MAX_ROW_LENGTH = 50;
  const [loadedRows, setLoadedRows] = React.useState([]);
  const [visible, setVisible] = React.useState(""); //holds row id's
  var pageRowsCount = 0;


  var columns = [
    {
      field: "dateFrom",
      headerName: "Додано",
      width: 90,
      renderCell: (cellValues) => {
        return <>{getDate(cellValues.row.dateFrom)}</>;
      },
    },
    {
      field: "dateEdit",
      headerName: "Редаговано",
      width: 90,
      renderCell: (cellValues) => {
        return <>{getDate(cellValues.row.dateEdit)}</>;
      },
    },
    {
      field: "rooms",
      headerName: "Кімнат",
      width: 90,
      type: "number",
    },
    {
      field: "cost",
      headerName: "Ціна(грн)",
      width: 130,
      type: "number",
    },
    { field: "currency", headerName: "Валюта", width: 130 },
    { field: "region", headerName: "Район", width: 130 },
    {
      field: "aboutClient",
      headerName: "Про клієнта",
      width: 130,
    },
    {
      field: "deadline",
      headerName: "Термін",
      width: 130,
      type: "number",
    },
    {
      field: "urgency",
      headerName: "Терміновість",
      width: 130,
    },
    { field: "personName", headerName: "Ім'я", width: 130 },
    {
      field: "phoneNumber",
      headerName: "Номер",
      width: 130,
      renderCell: (cellValues) => {
        return (
          <Stack direction="row" spacing={1} alignItems="center">
            {visible === cellValues.row.id ? (
              <>
                {cellValues.formattedValue}
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    setVisible("");
                  }}
                >
                  <VisibilityOff style={{ width: 15, height: 15 }} />
                </IconButton>
              </>
            ) : (
              <>
                {`******${cellValues.formattedValue.substring(
                  cellValues.formattedValue.length - 3,
                  cellValues.formattedValue.length
                )}`}
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    setVisible(cellValues.row.id);
                  }}
                >
                  <Visibility style={{ width: 15, height: 15 }} />
                </IconButton>
              </>
            )}
          </Stack>
        );
      },
    },
  ];

  if (admin) {
    columns.push({
      field: "info",
      type: "actions",
      width: 200,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<Info />}
          onClick={() => handleOpenInfo(params.id)}
          label="Info"
        />,
        <GridActionsCellItem
          icon={<Edit />}
          label="Edit"
          onClick={() => handleEditItem(params.id)}
        />,
        <GridActionsCellItem
          icon={<Delete />}
          label="Delete"
          onClick={() => handleDeleteItem(params.id)}
        />,
      ],
    });
  } else {
    columns.push({
      field: "info",
      type: "actions",
      width: 200,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<Info />}
          onClick={() => handleOpenInfo(params.id)}
          label="Info"
        />,
      ],
    });
  }

  // The table fills whatever vertical space is left under the header and the
  // view toggle, so the page itself never grows a second scrollbar.
  const boxRef = React.useRef(null);
  const fillHeight = useFillHeight(boxRef, 16, 360);

  return (
    <Box
      ref={boxRef}
      sx={{
        // Sized to the space actually left below it, not to a constant that
        // silently goes stale when anything above the table changes height.
        height: fillHeight == null ? window.innerHeight - 170 : fillHeight,
        minHeight: 360,
        mx: { xs: 1, md: 2 },
        mb: 2,
        backgroundColor: "#fff",
        border: "1px solid #E4E9F1",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
        <DataGrid
          sx={{
            ".MuiDataGrid-cellContent": {
              overflowWrap: "break-word",
            },
          }}
          disableSelectionOnClick
          disableColumnFilter={true}
          hideFooterSelectedRowCount
          getRowHeight={() => "auto"}
          rows={items}
          columns={columns}
          pageSize={MAX_ROW_LENGTH}
          rowsPerPageOptions={[MAX_ROW_LENGTH]}
          onPageChange={(pageNumber, details) => {
            if (items.length <= MAX_ROW_LENGTH * (pageNumber + 1)) {
              console.log("last page reached");
              loadNextClients();
            }
            pageRowsCount = items.length - MAX_ROW_LENGTH * pageNumber;
          }}
      />
    </Box>
  );
}
